module.exports = __webpack_public_path__ + "img/小红书.d0a3c24b.png";